// 请求前缀
// const ajaxUrl = 'http://wx.qiyu-soft.com:8066'
// const ajaxUrl = 'http://dhnj.qiyu-soft.com:8061'
// const ajaxUrl = 'http://wx.qiyu-soft.com'   // 2019-01-01
// const ajaxUrl = 'http://mp.qiyu-soft.com'


const ajaxUrl = 'https://eblock.qiyu-soft.com' //正式
// const ajaxUrl = 'http://eblock.qiyu-soft.com:8005' //电影院、音乐厅开发

// jsonp请求默认配置
const jsonpCommonOption = {
	param: 'jsoncallback',
	showLoading: true
}

// axios请求默认配置
const axiosCommonOption = {
	showLoading: true
}

export {
	ajaxUrl,
	jsonpCommonOption,
	axiosCommonOption,
}



// WEBPACK FOOTER //
// ./src/common/config.js